import { render, staticRenderFns } from "./UserFamilyItemParent.vue?vue&type=template&id=14329f88&scoped=true&"
import script from "./UserFamilyItemParent.vue?vue&type=script&lang=js&"
export * from "./UserFamilyItemParent.vue?vue&type=script&lang=js&"
import style0 from "./UserFamilyItemParent.vue?vue&type=style&index=0&id=14329f88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14329f88",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14329f88')) {
      api.createRecord('14329f88', component.options)
    } else {
      api.reload('14329f88', component.options)
    }
    module.hot.accept("./UserFamilyItemParent.vue?vue&type=template&id=14329f88&scoped=true&", function () {
      api.rerender('14329f88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UserFamilyItemParent.vue"
export default component.exports